import {Component} from '@angular/core';
import {AuthService} from 'src/app/service/autenticacao/auth.service';
import {FormArray, FormControl, FormGroup} from '@angular/forms';
import {FaleComRhService} from '../../../service/fale-com-rh/fale-com-rh.service';
import {ERRO_DADOS_NAO_GRAVADOS, OK_MANIFESTO_ENVIADO} from '../../../tools/Mensagens';
import {PAGINA_SUCESSO_FORM} from '../../../tools/URL';
import {Router} from '@angular/router';
import {FaleComRhBaseComponent} from "./common/fale-com-rh-base.component";
import {FaleComRhFormFactory} from "../../../service/fale-com-rh/fale-com-rh-form-factory.service";

@Component({
  selector: 'fale-com-rh',
  templateUrl: './fale-com-rh.component.html',
  styleUrls: ['./fale-com-rh.component.css']
})
export class FaleComRhComponent extends FaleComRhBaseComponent {

  mensagemRequerimento = 'Este canal é exclusivo para requerimentos de magistrados e servidores que não possuem mais vínculo ativo com o Tribunal de Justiça de Minas Gerais (aposentados, desligados), representantes ou interessados. Solicitações que não estiverem contempladas nestes casos não serão processadas.';

  role = 'servidor';
  identificadorSelecionado = 'servidor';
  assuntoSelecionado = '';
  formSubmitted = false;

  constructor(
    auth: AuthService,
    factory: FaleComRhFormFactory,
    private service: FaleComRhService,
    private router: Router
  ) {
    super(auth, factory);
  }


  submit() {
    this.formSubmitted = true;

    this.form.markAllAsTouched();
    this.sincronizarPrioridadePessoaIdosa();

    if (this.form.invalid) {
      alert('Preencha os campos obrigatórios');
      return;
    }

    let raw = this.form.getRawValue();
    let tipoAssunto = this.mapTipoAssunto(raw.tipoAssunto);


    let payload = {
      nome: raw.nome,
      email: raw.email,
      prioridadePessoaIdosa: raw.prioridadePessoaIdosa === true,
      tipoSolicitante: this.mapTipoSolicitante(raw.tipoSolicitante),
      procedimentoFeitoPorTerceiro: !!raw.procedimentoFeitoPorTerceiro,
      representanteLegal: raw.procedimentoFeitoPorTerceiro ? {
        nomeCompleto: raw.nomeRepresentanteLegal,
        cpf: raw.cpfRepresentanteLegal
      } : null,
      tipoAssunto: tipoAssunto,
      mensagem: this.getMensagem(raw),
      dadosCadastrais: null,
      contaBancaria: null,
      obito: null,
      solicitacaoDocumento: null,
      anexos: this.mapearAnexos(this.getGrupoNome(tipoAssunto)),
      anexosRepresentanteLegal: this.mapearAnexosRepresentanteLegal()
    };

    let dadosExtras = this.mapearDadosPorAssunto(tipoAssunto, raw);

    for (let key in dadosExtras) {
      payload[key] = dadosExtras[key];
    }

    this.service.salvar(payload).subscribe(retorno => {
      if (retorno) {
        alert(OK_MANIFESTO_ENVIADO);
        this.router.navigate([PAGINA_SUCESSO_FORM]).catch(function () {
          console.warn('Falha ao navegar para a página de sucesso');
        });
      } else {
        alert(ERRO_DADOS_NAO_GRAVADOS);
      }
    });
  }

  protected readonly FormGroup = FormGroup;
  protected readonly FormControl = FormControl;

  private sincronizarPrioridadePessoaIdosa() {
    const usuario: any = this.authService.usuarioDTO || {};
    this.form.get('prioridadePessoaIdosa').setValue(usuario.prioridadePessoaIdosa === true);
  }
}
